import { IHttpClient } from "../../../../lib/http";

/**
 * Paths are RELATIVE to the backoffice-manager client base (`BACKOFFICE_MANAGER_URL` = `/v6/api`,
 * which the admin host's VirtualService rewrites to bm's `/api`), so they start at `/v1/...`.
 * Prefixing `/api` here produced `/v6/api/api/v1/...` and a 404 in every environment behind the
 * gateway (found in the devel ephemeral on 2026-09-17).
 * REST companion to the gRPC `ExperimentGrpcRepository`, for the two CSV exports whose payload is
 * too large to want through gRPC-web.
 *
 * Both endpoints are served by **backoffice-manager**, reading the same warehouse marts the results
 * screen reads — `witbooking-api` is out of the experiment data path entirely (plan §5.7). The
 * caller supplies a client built with `useBackofficeClient()`, so these calls carry the same bearer
 * token and `x-property` header as every other backoffice-manager REST call in the app.
 *
 * Experiments are addressed by **id**, matching the gRPC surface, rather than by ticker as the old
 * `witbooking-api` route did — which removes that route's implicit "tickers are unique per
 * property" assumption.
 */
export class ExperimentBookingsApi {
  constructor(private readonly httpClient: IHttpClient) {}

  /** Booking-level detail for the experiment, one row per booking. */
  exportBookings(propertyTicker: string, experimentId: string): Promise<string> {
    return this.httpClient.get<string>(
      `/v1/${propertyTicker}/experiments/${experimentId}/bookings.csv`
    );
  }

  /** The daily aggregated series (exposures, conversions and their intervals), one row per bucket. */
  exportSeries(propertyTicker: string, experimentId: string): Promise<string> {
    return this.httpClient.get<string>(
      `/v1/${propertyTicker}/experiments/${experimentId}/series.csv`
    );
  }
}
